import type { WhiteboardDocumentId } from "@src/components/collaboration/document-id";
import { capture, normalizeBoardId } from "./core";
import type { BoardCreationType, PromptLengthBucket } from "./types";

export function captureBoardCreationSucceeded(
	boardId: WhiteboardDocumentId,
	creationType: BoardCreationType,
	promptLengthBucket?: PromptLengthBucket,
) {
	const payload: {
		board_id: string;
		creation_type: BoardCreationType;
		prompt_length_bucket?: PromptLengthBucket;
	} = {
		board_id: normalizeBoardId(boardId),
		creation_type: creationType,
	};

	if (creationType === "ai_generated" && promptLengthBucket) {
		payload.prompt_length_bucket = promptLengthBucket;
	}

	capture("board_creation_succeeded", payload);
}
